import { Component } from '@angular/core';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';

@Component({
  selector: 'app-alta-emisor-block',
  templateUrl: './alta-emisor-block.component.html',
  styleUrls: ['./alta-emisor-block.component.scss']
})
export class AltaEmisorBlockComponent {

  buttonWithIcon40pxHierarchy1: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Completar formulario',
    icon: Constants.ICONS.ARROW_RIGHT_FULL,
  };

  onForm() {
    window.open('https://forms.gle/6kv2iZcQ2SP5DoMd8','_blank'); 
   }

}
